/* eslint-disable */
module.exports = {
  /**
   * Inicializa hotjar
   * @param {*} id ID do Hotjar
   * @param {*} sv Versão do Hotjar
   */
  initialize: function (id, sv) {
    (function (h, o, t, j, a, r) {
      h.hj = h.hj || function () { (h.hj.q = h.hj.q || []).push(arguments) };
      h._hjSettings = { hjid: id, hjsv: sv };
      a = o.getElementsByTagName('head')[0];
      r = o.createElement('script'); r.async = 1;
      r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
      a.appendChild(r);
    })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
  },

  /**
   * Identificar o suaurio que estar utilizando
   * @param {*} id id do usuario
   * @param {*} data dados do usuario
   */
  identify: function (id, data) {
    window.hj('identify', id, JSON.stringify(data));
  }
};